import React from 'react';
import campoFrescoLogo from '../../assets/images/marcas/LOGOTIPO-ZOOM.png';
import puebloRicoLogo from '../../assets/images/marcas/LOGOTIPO_PUEBLO RICO.png';

const BrandsSection = () => {
  return (
    <div className="relative py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        {/* <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Nuestras <span className="text-green-600">Marcas</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Marcas reconocidas que garantizan la más alta calidad en productos alimentarios mexicanos
          </p>
        </div> */}

        {/* Marcas Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16 max-w-4xl mx-auto">          
          {/* Campo Fresco - Marca Principal */}
          <div className="group text-center">
            <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-12 hover:shadow-2xl transition-all duration-300 border border-green-100 hover:border-green-300">
              <div className="w-32 h-32 mx-auto mb-6 flex items-center justify-center group-hover:scale-125 transition-all duration-500 relative">
                <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full opacity-0 group-hover:opacity-20 blur-xl transition-all duration-500"></div>
                <div className="absolute inset-0 bg-gradient-to-r from-green-300 to-emerald-400 rounded-full animate-pulse opacity-10"></div>
                <img src={campoFrescoLogo} alt="Campo Fresco" className="w-28 h-28 object-contain relative z-10 drop-shadow-2xl group-hover:drop-shadow-[0_0_30px_rgba(34,197,94,0.5)] transition-all duration-500" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Campo Fresco</h3>
              <p className="text-gray-600 mb-4">
                Nuestra marca principal especializada en granos y leguminosas de la más alta calidad
                <br />
                 <br />
              </p>
              <div className="inline-block px-4 py-2 bg-green-100 text-green-700 rounded-full text-sm font-semibold">
                Marca Principal
              </div>
            </div>
          </div>         
           {/* Pueblo Rico */}
          <div className="group text-center">
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-3xl p-12 hover:shadow-2xl transition-all duration-300 border border-amber-100 hover:border-amber-300">
              <div className="w-32 h-32 mx-auto mb-6 flex items-center justify-center group-hover:scale-125 transition-all duration-500 relative">
                <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full opacity-0 group-hover:opacity-20 blur-xl transition-all duration-500"></div>
                <div className="absolute inset-0 bg-gradient-to-r from-amber-300 to-orange-400 rounded-full animate-pulse opacity-10"></div>
                <img src={puebloRicoLogo} alt="Pueblo Rico" className="w-28 h-28 object-contain relative z-10 drop-shadow-2xl group-hover:drop-shadow-[0_0_30px_rgba(245,158,11,0.5)] transition-all duration-500" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">Pueblo Rico</h3>
              <p className="text-gray-600 mb-4">
                Marca tradicional que ofrece productos auténticos con el sabor de nuestras tradiciones mexicanas
              </p>
              <div className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-sm font-semibold">
                Tradición Mexicana
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandsSection;
